import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnInit,
  Optional
} from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";

import {
  DEFAULT_FORM_ERROR_FORMATTERS,
  FORM_ERROR_FORMATTER_MAP
} from "./constants";
import { FormErrorFormatterMap } from "./models";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ta-form-errors-list",
  templateUrl: "form-errors-list.template.html"
})
export class FormErrorsListComponent implements OnInit {
  errorMessages$: Observable<string[]>;

  @Input()
  label?: string;

  @Input()
  set errors(val: { [key: string]: any } | undefined) {
    this.errors$.next(val);
  }
  private errors$ = new BehaviorSubject<{ [key: string]: any } | undefined>({});

  @Input()
  showUnformattedMessages = true;

  errorFormatters = DEFAULT_FORM_ERROR_FORMATTERS;

  constructor(
    @Inject(FORM_ERROR_FORMATTER_MAP)
    @Optional()
    customErrorFormatters: FormErrorFormatterMap
  ) {
    this.mergeErrorFormatters(customErrorFormatters);
  }

  ngOnInit(): void {
    this.initErrorMessages$();
  }

  private initErrorMessages$(): void {
    this.errorMessages$ = this.errors$.pipe(
      map((errorsMap) => this.reduceErrorMessages(errorsMap))
    );
  }

  private mergeErrorFormatters(
    customErrorFormatters?: FormErrorFormatterMap
  ): void {
    if (customErrorFormatters == null) {
      return;
    }

    this.errorFormatters = {
      ...this.errorFormatters,
      ...customErrorFormatters
    };
  }

  private reduceErrorMessages(errors?: { [key: string]: any }): string[] {
    if (errors == null) {
      return [];
    }

    return Object.keys(errors).reduce((messages, errorKey) => {
      const errorValue = errors[errorKey];
      const formatter = this.errorFormatters[errorKey];

      if (formatter != null) {
        const message = formatter(this.label, errorValue);
        return message != null ? [...messages, message] : messages;
      }

      if (this.showUnformattedMessages) {
        return [...messages, `Error: ${errorKey} ${errorValue}`];
      }

      return messages;
    }, []);
  }
}
